import type { ExcQuotemediaV1EodPriceJobKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../../util/routing/entity-paths';

export const QUOTEMEDIA_EOD_PRICE_JOB_BASE_PATH = getResolvedPath('/clearing/vendor/quote-media/job');

export const getQuotemediaEodPriceJobPath: EntityPathBuilder<ExcQuotemediaV1EodPriceJobKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return QUOTEMEDIA_EOD_PRICE_JOB_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.jobId) {
        return undefined;
      }

      return getResolvedPath(`${QUOTEMEDIA_EOD_PRICE_JOB_BASE_PATH}/$jobId`, context.keys);
    }
  }
};

export function getQuotemediaEodPriceJobDetailPath(jobId: string | undefined) {
  if (!jobId) {
    return undefined;
  }

  return getQuotemediaEodPriceJobPath({ kind: 'detail', keys: { jobId } });
}
